import { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './PaymentSuccess.css';

export default function PaymentSuccess() {
  const [params]    = useSearchParams();
  const navigate    = useNavigate();
  const [status, setStatus]   = useState('verifying'); // verifying | success | error
  const [challengeId, setChallengeId] = useState(null);

  useEffect(() => {
    const sessionId = params.get('session_id');
    if (!sessionId) { navigate('/dashboard'); return; }

    api.get(`/payments/verify/${sessionId}`)
      .then(({ data }) => {
        if (data.paid) {
          setChallengeId(data.challengeId);
          setStatus('success');
        } else {
          setStatus('error');
        }
      })
      .catch(() => setStatus('error'));
  }, [params, navigate]);

  if (status === 'verifying') {
    return (
      <div className="ps-page">
        <div className="ps-card fade-in-up">
          <div className="ps-spinner" />
          <p className="text-secondary">Verifying your payment…</p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="ps-page">
        <div className="ps-card fade-in-up">
          <div className="ps-icon error">✕</div>
          <h2>Payment not confirmed</h2>
          <p className="text-secondary">
            We couldn't verify your payment. If you were charged, please contact support.
          </p>
          <Link to="/pricing" className="btn btn-outline" style={{ marginTop: 24 }}>
            Back to Pricing
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="ps-page">
      <div className="ps-card fade-in-up">
        <div className="ps-icon success">✓</div>
        <h2>Challenge Activated!</h2>

        <p className="text-secondary" style={{ lineHeight: 1.7 }}>
          Your simulated funded account has been created. The trading bot is ready to use.
          Remember — all trades, balances, and payouts are <strong style={{ color: 'var(--gold)' }}>100% simulated</strong>.
        </p>

        <div className="ps-actions">
          {challengeId ? (
            <Link to={`/challenge/${challengeId}`} className="btn btn-primary btn-lg">
              Go to Challenge →
            </Link>
          ) : (
            <Link to="/dashboard" className="btn btn-primary btn-lg">
              Go to Dashboard →
            </Link>
          )}
          <Link to="/pricing" className="btn btn-outline">Buy Another Plan</Link>
        </div>
      </div>
    </div>
  );
}
